import { useState, useRef } from "react";

import styles from "./index.module.scss"
import useClickOutside from "../../../hooks/useClickOutside";
import CloseIcon from "../../../assets/icons/CloseIcon"
import InfoIcon from "../../../assets/icons/InfoIcon"
import InfoIconSolid from "../../../assets/icons/InfoIconSolid"

function RcmpToolTipTrigger(props) {
  const { bIsOpen, ...oRest } = props

  if (!bIsOpen) return <InfoIcon {...oRest} />

  return <InfoIconSolid {...oRest} />
}

export default function RcmpTooltip(props) {
  const { children, bOnHover = false } = props
  const [bIsOpen, fnSetBisOpen] = useState(false)

  const containerRef = useRef(null)
  useClickOutside(containerRef, () => fnSetBisOpen(false))

  const fnToggleToolTip = () => {
    if (bOnHover) {
      fnSetBisOpen(true)
      return
    }
    fnSetBisOpen(!bIsOpen)
  }

  const fnCloseToolTip = () => {
    if (bOnHover) {
      fnSetBisOpen(false)
      return
    }
  }

  return (
    <div ref={containerRef} className={styles.tooltipContainer} onMouseEnter={fnToggleToolTip} onMouseLeave={fnCloseToolTip}>
      <RcmpToolTipTrigger bIsOpen={bIsOpen} onClick={fnToggleToolTip} />
      {bIsOpen && (
        <div className={styles.tooltipFloatContainer}>
          {!bOnHover && <div className={styles.closeButton}>
            <CloseIcon onClick={fnToggleToolTip} fill="#6CB6E3" />
          </div>}
          {children}
        </div>
      )}
    </div>
  )
}

